import React from 'react';
import ReactDOM from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { BrowserTracing } from '@sentry/tracing';
import ErrorFallback from 'shared/components/ErrorFallback';
import lazyWithRetry from './lazyWithRetry';

const App = lazyWithRetry(() => import('./App'));

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
  beforeSend(event, hint) {
    if (hint.originalException === 'Timeout') return null;
    return event;
  },
});

const myFallback = <ErrorFallback />;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Sentry.ErrorBoundary fallback={myFallback}>
    <App />
  </Sentry.ErrorBoundary>
);
